/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var app   = require('mag-app'),

    Modal = require('mag-component-modal'),
    List  = require('mag-component-layout-list'),
    onclickCallback,
    lastActiveComponent,
    modal;


modal = new Modal({
    title: gettext('Exit'),
    events: {
        show: function () {
            this.children[0].focus();
        },
        hide: function () {
            lastActiveComponent.focus();
        },
        keydown: function ( event ) {
            event.stop = true;
        }
    },
    children: [
        new List({
            className: 'padded',
            focusIndex: 0,
            size: 2,
            data: [
                {
                    items: [{value: gettext('Yes')}],
                    click: function () {
                        // process success
                        onclickCallback(true);
                        modal.hide();
                    }
                },
                {
                    items: [{value: gettext('No')}],
                    click: function () {
                        // process cancel
                        onclickCallback(false);
                        modal.hide();
                    }
                }
            ]
        })
    ]
});

core.addListener('hide', function ( /*event*/ ) {

    modal.hide();

});

module.exports = function ( page ) {

    page.add(modal);

    return function ( callback ) {
        if ( app.activePage && app.activePage.activeComponent ) {
            lastActiveComponent = app.activePage.activeComponent;
        }

        onclickCallback = callback;
        modal.show();
    };
};
